var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      width: 850,
      title: _vm.$t(
        "label_essweb_myClaimApplication_form_dialog_viewClaimItemTitle"
      ),
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Taber", {
              attrs: {
                curTab: _vm.curTab,
                items: _vm.taber,
                backgroundColor: "white",
              },
              on: { change: _vm.onChange },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      items: _vm.claimTypeList,
                                      "append-icon": _vm.iSEdited
                                        ? "arrow_drop_down"
                                        : "",
                                      "item-text": "view_fields",
                                      "item-value": "value_field",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel"
                                      ),
                                      "single-line": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.ClaimItemData.claim_item_type_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimItemData,
                                          "claim_item_type_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimItemData.claim_item_type_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_claimItemNameLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.ClaimItemData.claim_item_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimItemData,
                                          "claim_item_name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimItemData.claim_item_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              Number(
                                _vm.propertys[
                                  "is_allow_apply|is_include_pay_date"
                                ]["value"]
                              )
                                ? _c(
                                    "v-col",
                                    [
                                      _c("DateTimePicker", {
                                        attrs: {
                                          rules: _vm.$GetRules(
                                            ["_Require_Rules"],
                                            [null]
                                          ),
                                          defaultTime:
                                            _vm.ClaimItemData
                                              .payout_utc_datetime,
                                          type: "date",
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_dialog_consumptionDateLabel"
                                          ),
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          placeholder: "YYYY/MM/DD",
                                        },
                                        on: {
                                          change: function (time) {
                                            _vm.ClaimItemData.payout_utc_datetime =
                                              time
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              Number(
                                _vm.propertys2["is_show_claim_reason"]["value"]
                              )
                                ? _c(
                                    "v-col",
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass:
                                            "text--secondary pl-1 mrc_text_require",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimRecord_form_dialog_claimReasonLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("v-select", {
                                        attrs: {
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          items: _vm.claimReasonList,
                                          "append-icon": _vm.iSEdited
                                            ? "arrow_drop_down"
                                            : "",
                                          "item-text": "view_fields",
                                          "item-value": "value_field",
                                          rules: _vm.$GetRules(
                                            ["_Require_Rules"],
                                            [null]
                                          ),
                                          dense: "",
                                          placeholder: _vm.$t(
                                            "label_essweb_ClaimRecord_form_dialog_claimReasonLabel"
                                          ),
                                          "single-line": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "no-data",
                                              fn: function () {
                                                return [_c("noContent")]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3871233564
                                        ),
                                        model: {
                                          value:
                                            _vm.ClaimItemData.claim_reason_uuid,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ClaimItemData,
                                              "claim_reason_uuid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ClaimItemData.claim_reason_uuid",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_descriptionLabel"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.ClaimItemData
                                          .claim_item_description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimItemData,
                                          "claim_item_description",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimItemData.claim_item_description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form2", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              Number(
                                _vm.propertys.is_allow_attachment["value"]
                              ) && Number(_vm.isAllowViewAttachments)
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "12",
                                        md: "12",
                                        lg: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-sheet",
                                        { staticClass: "text--secondary" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimRecord_form_dialog_attachmentLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("ImgDragUpdate", {
                                        attrs: {
                                          defaultImageList:
                                            _vm.ClaimItemData.attachments,
                                          disabled: !_vm.iSEdited,
                                        },
                                        on: {
                                          change: function (img) {
                                            return (_vm.ClaimItemData.attachments =
                                              img)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_swiftNumberLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                    model: {
                                      value:
                                        _vm.ClaimItemData.receipt_swift_number,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimItemData,
                                          "receipt_swift_number",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ClaimItemData.receipt_swift_number",
                                    },
                                  }),
                                ],
                                1
                              ),
                              Number(
                                _vm.propertys.is_related_to_cost_center["value"]
                              )
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass:
                                            "mrc_text_require text--secondary",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "label_essweb_ClaimRecord_form_dialog_costCentreLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c("v-select", {
                                        attrs: {
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          items: _vm.costCenter,
                                          "append-icon": _vm.iSEdited
                                            ? "arrow_drop_down"
                                            : "",
                                          "item-text": "view_fields",
                                          "item-value": "value_field",
                                          rules: _vm.$GetRules(
                                            ["_Require_Rules"],
                                            [null]
                                          ),
                                          dense: "",
                                          placeholder: _vm.$t(
                                            "label_essweb_ClaimRecord_form_dialog_costCentreLabel"
                                          ),
                                          "single-line": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "no-data",
                                              fn: function () {
                                                return [_c("noContent")]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3871233564
                                        ),
                                        model: {
                                          value:
                                            _vm.ClaimItemData.cost_center_uuid,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ClaimItemData,
                                              "cost_center_uuid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ClaimItemData.cost_center_uuid",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form3", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              Number(
                                _vm.propertys[
                                  "is_allow_apply|is_include_actual_amount"
                                ]["value"]
                              )
                                ? _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xs: "12",
                                        sm: "6",
                                        md: "6",
                                        lg: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("normalInputTextFiled", {
                                        attrs: {
                                          type: "number",
                                          readonly: !_vm.iSEdited,
                                          filled: _vm.iSEdited,
                                          height: "32",
                                          message: _vm.curMessage,
                                          rules: _vm.$GetRules(
                                            ["_Number_negative"],
                                            [null]
                                          ),
                                          label: _vm.$t(
                                            "label_essweb_ClaimRecord_form_dialog_actualAmountLabel"
                                          ),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "prepend-inner",
                                              fn: function () {
                                                return [
                                                  _c("v-select", {
                                                    staticClass:
                                                      "special_input_text",
                                                    class: !_vm.iSEdited
                                                      ? ""
                                                      : "ml-n3",
                                                    staticStyle: {
                                                      width: "120px",
                                                      "margin-top": "-9px",
                                                      "background-color":
                                                        "transparent",
                                                      "box-shadow": "none",
                                                      background: "transparent",
                                                    },
                                                    attrs: {
                                                      items: _vm.currencyCodes,
                                                      filled: _vm.iSEdited,
                                                      height: "41",
                                                      readonly:
                                                        !_vm.iSEdited ||
                                                        !Number(
                                                          _vm.propertys
                                                            .is_allow_choose_currency[
                                                            "value"
                                                          ]
                                                        ),
                                                      "hide-details": "",
                                                      "append-icon":
                                                        Number(
                                                          _vm.propertys
                                                            .is_allow_choose_currency[
                                                            "value"
                                                          ]
                                                        ) && _vm.iSEdited
                                                          ? "arrow_drop_down"
                                                          : "",
                                                      "item-text":
                                                        "currency_code",
                                                      "item-value": "uuid",
                                                      rules: _vm.$GetRules(
                                                        ["_Require_Rules"],
                                                        [null]
                                                      ),
                                                      dense: "",
                                                      placeholder: _vm.$t(
                                                        "label_essweb_ClaimRecord_form_dialog_currencyLabel"
                                                      ),
                                                      "single-line": "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "no-data",
                                                          fn: function () {
                                                            return [
                                                              _c("noContent"),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      3871233564
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.ClaimItemData
                                                          .actual_currency_uuid,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ClaimItemData,
                                                          "actual_currency_uuid",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ClaimItemData.actual_currency_uuid",
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2463515072
                                        ),
                                        model: {
                                          value:
                                            _vm.ClaimItemData.actual_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ClaimItemData,
                                              "actual_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ClaimItemData.actual_amount",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      type: "number",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Number_negative"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_claimAmountLabel"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "prepend-inner",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "120px",
                                                  "line-height": "40px",
                                                  "margin-top": "-9px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.ClaimItemData
                                                        .claim_currency_code
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.ClaimItemData.claim_amount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ClaimItemData,
                                          "claim_amount",
                                          $$v
                                        )
                                      },
                                      expression: "ClaimItemData.claim_amount",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      disabled: true,
                                      type: "number",
                                      filled: false,
                                      suffix:
                                        _vm.ClaimItemData.approved_amount.toString(),
                                      label: _vm.$t(
                                        "label_essweb_ClaimRecord_form_dialog_approvalAmountLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "prepend-inner",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "120px",
                                                  "line-height": "40px",
                                                  "margin-top": "-9px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.ClaimItemData
                                                        .claim_currency_code
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: { save: _vm.toSave, cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }